/**
 *  Lazy load of pictures
 */
import LazyLoad from 'vanilla-lazyload';

window.lazyload = new LazyLoad({});

setInterval(function() {
  if (document.body.classList.contains('elementor-editor-active')) {
    window.lazyload.update();
  }
}, 500);
